import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { creditMemoKeys } from '@/lib/queryKeys';
import { creditMemoEndpoints } from '@/lib/api/endpoints';
import { apiPost, operationsClient } from '@/lib/api/client';
import type { CashOutCreditMemoInput } from '@/types/creditMemo';

interface CashOutResult {
  id: string;
  status: string;
  refundedAmount: number;
}

export function useCashOutCreditMemo(creditMemoId: string) {
  const queryClient = useQueryClient();

  return useApiMutation<CashOutResult, CashOutCreditMemoInput>({
    mutationFn: (input) =>
      apiPost<CashOutResult, CashOutCreditMemoInput>(
        operationsClient,
        creditMemoEndpoints.cashOut(creditMemoId),
        input,
      ),
    onSuccess: (result) => {
      void queryClient.invalidateQueries({
        queryKey: creditMemoKeys.detail(creditMemoId),
      });
      void queryClient.invalidateQueries({ queryKey: creditMemoKeys.lists() });
      toast.success(`Cashed out $${result.refundedAmount.toFixed(2)}`);
    },
  });
}
